import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }
    
    if (formData.message.length > 500) {
      alert('A mensagem não pode exceder 500 caracteres.');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus('idle');
    
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);
      
      const response = await fetch('https://readdy.ai/api/form/d4eb9kdu34gl8hoks5s0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });
      
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contato" className="py-8 md:py-20 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-green-800 mb-3">Entre em Contato</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-3 md:mb-6"></div>
          <p className="text-sm md:text-xl text-gray-700 max-w-3xl mx-auto">
            Tem dúvidas sobre nossos produtos ou quer fazer um pedido? Estamos aqui para ajudar!
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-xl p-5 md:p-12">
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-xs md:text-base">
                    Nome Completo <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 text-xs md:text-sm"
                    placeholder="Seu nome"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-xs md:text-base">
                    E-mail <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 text-xs md:text-sm"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6">
                <div>
                  <label htmlFor="phone" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-xs md:text-base">
                    Telefone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 text-xs md:text-sm"
                    placeholder="(83) 99999-9999"
                  />
                </div>
                
                <div>
                  <label htmlFor="subject" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-xs md:text-base">
                    Assunto
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 text-xs md:text-sm pr-8 cursor-pointer"
                  >
                    <option value="">Selecione um assunto</option>
                    <option value="produtos">Informações sobre produtos</option>
                    <option value="pedido">Fazer um pedido</option>
                    <option value="parceria">Parceria comercial</option>
                    <option value="visita">Agendar visita</option>
                    <option value="outro">Outro</option>
                  </select>
                </div>
              </div>
              
              <div className="mb-4 md:mb-6">
                <label htmlFor="message" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-xs md:text-base">
                  Mensagem <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 text-xs md:text-sm resize-none"
                  placeholder="Escreva sua mensagem aqui..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1 md:mt-2">
                  {formData.message.length}/500 caracteres
                </p>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 md:py-4 md:px-8 rounded-lg text-sm md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
              </button>
              
              {submitStatus === 'success' && (
                <div className="mt-4 md:mt-6 bg-green-100 border border-green-400 text-green-700 px-3 py-2 md:px-4 md:py-3 rounded-lg">
                  <p className="font-semibold text-xs md:text-base">Mensagem enviada com sucesso!</p>
                  <p className="text-xs md:text-sm">Entraremos em contato em breve.</p>
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mt-4 md:mt-6 bg-red-100 border border-red-400 text-red-700 px-3 py-2 md:px-4 md:py-3 rounded-lg">
                  <p className="font-semibold text-xs md:text-base">Erro ao enviar mensagem.</p>
                  <p className="text-xs md:text-sm">Por favor, tente novamente ou entre em contato por telefone.</p>
                </div>
              )}
            </form>
          </div>
          
          <div className="mt-6 md:mt-12 grid md:grid-cols-3 gap-4 md:gap-6">
            <a
              href="https://wa.me/5583999845954"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white p-4 md:p-6 rounded-lg text-center transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl md:text-4xl mb-2 md:mb-3"></i>
              <p className="font-bold text-sm md:text-lg">WhatsApp</p>
              <p className="text-xs md:text-sm">(83) 99984-5954</p>
            </a>
            
            <a
              href="https://instagram.com/laticinio_agubel"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-br from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white p-4 md:p-6 rounded-lg text-center transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-instagram-line text-2xl md:text-4xl mb-2 md:mb-3"></i>
              <p className="font-bold text-sm md:text-lg">Instagram</p>
              <p className="text-xs md:text-sm">@laticinio_agubel</p>
            </a>
            
            <a
              href="https://facebook.com/laticinoagubel"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white p-4 md:p-6 rounded-lg text-center transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-facebook-box-line text-2xl md:text-4xl mb-2 md:mb-3"></i>
              <p className="font-bold text-sm md:text-lg">Facebook</p>
              <p className="text-xs md:text-sm">Laticínio Agubel</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
